export interface SetCookieOptions {
    domain?: string;
    path?: string;
    expires?: Date;
    maxAge?: number;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
}

export function getCookie(name: string): string | null {
    if (typeof document === 'undefined') {
        return null;
    }

    const prefix = `${name}=`;
    const entry = document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(prefix));

    if (!entry) {
        return null;
    }

    return decodeURIComponent(entry.slice(prefix.length));
}

export function setCookie(name: string, value: string, options: SetCookieOptions = {}): void {
    if (typeof document === 'undefined') {
        return;
    }

    const parts = [`${name}=${encodeURIComponent(value)}`];

    if (options.domain) {
        parts.push(`Domain=${options.domain}`);
    }

    parts.push(`Path=${options.path ?? '/'}`);

    if (options.expires) {
        parts.push(`Expires=${options.expires.toUTCString()}`);
    }

    if (options.maxAge !== undefined) {
        parts.push(`Max-Age=${options.maxAge}`);
    }

    if (options.secure) {
        parts.push('Secure');
    }

    if (options.sameSite) {
        parts.push(`SameSite=${options.sameSite}`);
    }

    document.cookie = parts.join('; ');
}
